export default __webpack_public_path__ + "static/media/Startup_Chile.2f6055e0.svg";